import React from "react";
import classes from "./Features.module.scss";
const Features = ({ p1, p2 }) => {
  return (
    <section className={`${classes.features} ${classes.container}`}>
      <div className={classes.features_desc}>
        <h2 className={classes.features_heading}>Features</h2>
        <p className={classes.first_paragraph}>
          {p1}
          {/* Reap the advantages of a flat diaphragm tweeter cone. This provides a
          fast response rate and excellent high frequencies that lower tiered
          bookshelf speakers cannot provide. The woofers are made from aluminum
          that produces a unique and clear sound. XLR inputs allow you to
          connect to a mixer for more advanced usage.{" "} */}
        </p>
        <p className={classes.second_paragraph}>
          {p2}
          {/* The ZX7 speaker is the perfect blend of stylish design and high
          performance. It houses an encased MDF wooden enclosure which minimises
          acoustic resonance. Dual connectivity allows pairing through bluetooth
          or traditional optical and RCA input. Switch input sources and control
          volume at your finger tips with the included wireless remote. This
          versatile speaker is equipped to deliver an authentic listening
          experience. */}
        </p>
      </div>
      <div className={classes.inTheBox__}>
        <h2 className={classes.features_heading}>In the box</h2>
        <section className={classes.items}>
          <div className={[`${classes.item} ${classes.speaker_unit}`]}>
            {" "}
            <span className={classes.quantity}>2x</span>{" "}
            <span className={classes.unit}>Speaker unit</span>
          </div>
          <div className={[`${classes.item} ${classes.speaker_clothPanel}`]}>
            <span className={classes.quantity}>2x</span>{" "}
            <span className={classes.unit}>Speaker cloth panel</span>
          </div>
          <div className={[`${classes.item} ${classes.userManual}`]}>
            <span className={classes.quantity}>1x</span>{" "}
            <span className={classes.unit}>User manual</span>{" "}
          </div>
          <div className={[`${classes.item} ${classes.audio_cable}`]}>
            <span className={classes.quantity}>1x</span>{" "}
            <span className={classes.unit}>3.5mm 7.5m audio cable</span>{" "}
          </div>
          <div className={[`${classes.item} ${classes.optical_cable}`]}>
            <span className={classes.quantity}>1x</span>{" "}
            <span className={classes.unit}>7.5m optical cable</span>{" "}
          </div>
        </section>
      </div>
    </section>
  );
};

export default Features;
